import eventBus from '../../utils/EventBus';

const lozad = require('lozad');
const constants = require('../../constants');

const hideListOfCategories = elList => elList.forEach(el => $(el).hide());
const hideAllImages = () => $('.right .category-info')
    .children()
    .each((_i, el) => $(el).hide());

const deselectActiveCategory = () => $('.left-panel .list-group .list-group-item').removeClass('selected');

const maxColumnItems = 8;

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}

eventBus.subscribe('parentCategoryChanges', (e) => {
    const wrapperLeft = $('.wrapper .left');
    const wrapperRight = $('.wrapper .right');
    const menuDesktopDiv = document.querySelector('.menu-desktop');
    const thirdLevelCategories = document.querySelectorAll(
        '.wrapper .left .list-group .list-group-item',
    );

    triggerLozad();

    $(wrapperLeft).css('flex', '0 1 0%');
    hideAllImages();

    const elementImage = wrapperRight.find(`#${e.target.firstElementChild.id}`);
    if (elementImage.length) {
        wrapperRight.find(`#${e.target.firstElementChild.id}`).show();
    }

    let secondLevelCategoriesCount = 0;
    const secondLevelCategories = document.querySelectorAll(
        '.left-panel .list-group .list-group-item',
    );

    if (e.target.firstElementChild.id !== $(menuDesktopDiv).data('elTrigger')) {
        hideListOfCategories(thirdLevelCategories);
    }

    secondLevelCategories.forEach((element) => {
        if ($(element).data('category') !== e.target.firstElementChild.id) {
            $(element).hide();
        } else {
            secondLevelCategoriesCount += 1;
            $(element).show();
        }
    });

    if (!$(menuDesktopDiv).hasClass('active') && secondLevelCategoriesCount > 0) {
        $(menuDesktopDiv).addClass('active');
    }

    $(menuDesktopDiv).data('elTrigger', e.target.firstElementChild.id);
    $(e.target).addClass('active');
    deselectActiveCategory();
});

eventBus.subscribe('parentCategoryLeaves', (e) => {
    const menuDesktopDiv = document.querySelector('.menu-desktop');
    $(menuDesktopDiv).removeClass('active');
    $(e.target).removeClass('active');
});

eventBus.subscribe('secondLevelCategoryChanges', (el) => {
    const wrapperLeft = $('.wrapper .left');
    const wrapperRight = $('.wrapper .right');
    const thirdLevelOneColumn = $('.third-level-one-column').length;
    const thirdLevelCategories = document.querySelectorAll(
        '.wrapper .left .list-group .list-group-item',
    );

    let thirdLevelCategoriesCount = 0;
    let hasSubCategories = false;

    thirdLevelCategories.forEach((element) => {
        if ($(element).data('subcategory') !== $(el).data('subcategory')) {
            $(element).hide();
        } else {
            $(element).show(0, () => {
                const callback = () => {
                    eventBus.broadcast('thirdLevelCategoryChanges', element);
                };

                const disableCallback = () => {
                    element.removeEventListener('mouseover', callback);
                    element.removeEventListener('mouseleave', disableCallback);
                };

                element.addEventListener('mouseover', callback);
                element.addEventListener('mouseleave', disableCallback);
            });

            thirdLevelCategoriesCount += 1;
            hasSubCategories = true;
        }
    });

    const columnsCount = Math.ceil(thirdLevelCategoriesCount / maxColumnItems);

    if (hasSubCategories) {
        if (columnsCount >= 2 && thirdLevelOneColumn <= 0) {
            wrapperLeft.css('flex', '2 1 0%');
            wrapperRight.css('flex', '2 1 0%');
            wrapperLeft.addClass('columns-2');
            wrapperLeft.removeClass('columns-1');
        } else {
            wrapperLeft.css('flex', '1 1 0%');
            wrapperRight.css('flex', '4 1 0%');
            wrapperLeft.addClass('columns-1');
            wrapperLeft.removeClass('columns-2');
        }
    } else {
        wrapperLeft.css('flex', '0 1 0%');
        wrapperRight.css('flex', '3 1 0%');
    }

    deselectActiveCategory();
    triggerLozad();

    const dataCategodyID = $(el).data('category');
    const dataSubcategodyID = $(el).data('subcategory');
    const categoryImage = $(`.right .category-image#${dataCategodyID}`);
    const subcategoryImage = $(`.right .category-image#${dataSubcategodyID}`);
    if (subcategoryImage.length) {
        hideAllImages();
        subcategoryImage.show();
    } else if (categoryImage.length) {
        hideAllImages();
        categoryImage.show();
    }

    $(el).addClass('selected');
});

eventBus.subscribe('thirdLevelCategoryChanges', (el) => {
    const dataSubcategodyID = $(el).data('subcategory');
    const subcategoryImage = $(`.right .category-image#${dataSubcategodyID}`);
    const thirdLevelCategodyID = $(el).data('id');
    const thirdLevelCategoryImage = $(`.right .category-image#${thirdLevelCategodyID}`);
    if (thirdLevelCategoryImage.length) {
        hideAllImages();
        thirdLevelCategoryImage.show();
    } else if (subcategoryImage.length) {
        hideAllImages();
        subcategoryImage.show();
    }
});

export default async () => {
    const menuDesktopDiv = document.querySelector('.menu-desktop');

    if (menuDesktopDiv) {
        const menuItems = $('.header.container .main-menu').length ? '.header.container .main-menu .menu-group .nav .nav-item' : '.header.container + .main-menu .menu-group .nav .nav-item';
        const desktopMenuLi = document.querySelectorAll(
            menuItems,
        );
        const response = await $.ajax({
            url: $(menuDesktopDiv).data('url'),
            type: 'get',
        });

        $(menuDesktopDiv)
            .find('.main-wrapper')
            .html(response);

        const leftMenuSubcategories = document.querySelectorAll(
            '.menu-desktop .main-wrapper .left-panel .list-group .list-group-item',
        );

        const thirdLevelSubcategories = document.querySelectorAll(
            '.menu-desktop .main-wrapper .wrapper .list-group .list-group-item',
        );

        desktopMenuLi.forEach((el) => {
            el.addEventListener('mouseenter', (e) => {
                eventBus.broadcast('parentCategoryChanges', e);
            });

            el.addEventListener('mouseleave', (e) => {
                eventBus.broadcast('parentCategoryLeaves', e);
            });
        });

        menuDesktopDiv.addEventListener('mouseenter', () => {
            if (!$(menuDesktopDiv).hasClass('active')) {
                $(menuDesktopDiv).addClass('active');
            }

            $(`#${$(menuDesktopDiv).data('elTrigger')}`)
                .parent()
                .addClass('active');
            triggerLozad();
        });

        menuDesktopDiv.addEventListener('mouseleave', () => {
            $(menuDesktopDiv).removeClass('active');
            $(`#${$(menuDesktopDiv).data('elTrigger')}`)
                .parent()
                .removeClass('active');
        });

        leftMenuSubcategories.forEach((el) => {
            el.addEventListener('mouseenter', () => {
                eventBus.broadcast('secondLevelCategoryChanges', el);
            });
        });

        thirdLevelSubcategories.forEach((el) => {
            el.addEventListener('mouseenter', () => {
                eventBus.broadcast('thirdLevelCategoryChanges', el);
            });
        });
    }

    const mainMenuOverlay = $('.menu-toggleable-left + .overlay');
    mainMenuOverlay.on('click', (e) => {
        e.preventDefault();
        $('#menuMobileToggler').trigger('click');
    });

    $('#menuMobileToggler').on('click', (e) => {
        const thisTarget = $(e.currentTarget);
        const htmlBody = $('html, body');
        const mainMenuMobile = $('.menu-toggleable-left');
        // All menu items except the currently open menu item are retrieved
        const activeDropdownMenus = $('.menu-toggleable-left .nav-item:not(.show.open) .dropdown-menu');
        const header = $('header');
        let timeout = 0;

        if($('.pdp-info-container').hasClass('expanded')){
            $('.pdp-info-container').removeClass('expanded');
        }

        if ($('.search-visible').length) {
            $('.site-search-wrapper .site-search').slideUp('fast');
            $('.header-icons .icon-search-line, .fake-input-placeholder').removeClass('active');
            $('.page').removeClass('search-visible');
            $('.site-search .overlay').fadeOut();
            timeout = 300;
        }

        setTimeout(() => {
            thisTarget.toggleClass('active');
            if (thisTarget.hasClass('active')) {
                const headerHeight = header.height();
                header.addClass('menu-active');
                htmlBody.addClass('no-overflow');
                mainMenuOverlay.fadeIn();
                mainMenuMobile.css('top', `${headerHeight}px`);
                mainMenuOverlay.css('top', `${headerHeight}px`);
            } else {
                header.removeClass('menu-active');
                htmlBody.removeClass('no-overflow');
                mainMenuMobile.css('height', 'unset');
                mainMenuOverlay.fadeOut();
                activeDropdownMenus.slideUp();
            }
        }, timeout);
    });

    $('.no-click').on('click', (e) => {
        e.preventDefault();
    });

    $('.main-menu').on('click', '.navbar .menu-group .nav.navbar-nav > .nav-item > .nav-link', (e) => {
        const desktopEvent = window.outerWidth >= constants.viewport_bootstrap.lg;
        const thisTarget = $(e.currentTarget);
        if (thisTarget.hasClass('no-click')) {
            e.preventDefault();
        } else if (desktopEvent) {
            window.location = thisTarget.attr('href');
        }
    });

    $('.menu-toggleable-left li .nav-link:not(.custom-link)').on('click', (e) => {
        e.preventDefault();
        let mainTarget = $(e.target);
        const menuImageBlock = $('header .menu-image');
        mainTarget = !mainTarget.is('span') && !mainTarget.is('div') ? mainTarget.find('.category-name') : mainTarget;
        if (!mainTarget.parents('a').hasClass('dropdown-toggle')) {
            window.location = mainTarget.parents('a').attr('href');
        }

        if (mainTarget.parents('a').find('.icon-container').length) {
            // button down
            mainTarget = mainTarget.parents('a').find('.icon-isclosed');
            const parentLi = mainTarget.parents('li');
            const dropDownMenu = parentLi.find('> .submenu-wrapper > .dropdown-menu');

            $('icon-container').not(mainTarget).removeClass('open');
            mainTarget.toggleClass('icon-isopen');
            parentLi.toggleClass('dropdown-open');
            dropDownMenu.slideToggle();
        } else {
            // button left or right
            e.preventDefault();
            const parentLi = mainTarget.parents('li');
            const dropDownMenu = parentLi.find('> .dropdown-menu');
            mainTarget = mainTarget.closest('a').find('.icon-isclosed').hasClass('open') ? mainTarget.closest('a').find('.icon-isopen') : mainTarget.closest('a').find('.icon-isclosed');
            $('icon-container').not(mainTarget).removeClass('open');
            if (mainTarget.hasClass('icon-isclosed')) {
                mainTarget.addClass('open');
                parentLi.addClass('open');
                dropDownMenu.slideDown('fast');
                menuImageBlock.fadeOut();
            } else {
                dropDownMenu.slideUp('fast');
                mainTarget.removeClass('open');
                parentLi.removeClass('open');
                mainTarget.closest('a').find('.icon-isclosed').removeClass('open');
                menuImageBlock.fadeIn();
            }
        }
    });


    $('.main-menu, .category-breadcrumb').find('a').each((index, node) => {
        $(node).on('click', () => {
            window.sessionStorage.setItem('newCategory', true);
        });
    });

    triggerLozad();
};
